import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'checked-out-guest',
  templateUrl: './checked-out-guest.component.html',
  styleUrls: ['./checked-out-guest.component.scss']
})
export class CheckedOutGuestComponent {

  title: string;
  constructor(private translate: TranslateService) {
    this.translate.use('hu')
    this.title = translate.instant('checkedoutguest.title')

  }

}
